import React, {useEffect, useRef, useState} from 'react';
import {Button} from 'react-bootstrap';
import {useReactToPrint} from 'react-to-print';

const formatThaiDate = (input: string) => {
  if (!input) return '';

  const [dateStr] = input.split('@');
  const [year, month, day] = dateStr.split('-');

  const thaiMonths = [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม'
  ];

  const thaiMonth = thaiMonths[parseInt(month, 10) - 1];
  const thaiYear = parseInt(year, 10) + 543;

  return `${parseInt(day, 10)} ${thaiMonth} ${thaiYear}`;
};

const Card = ({trainee, score, trainer, item}: any) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      marginBottom: '1cm',
      pageBreakInside: 'avoid'
    }}
  >
    <div
      style={{
        display: 'flex',
        width: '20cm',
        height: '6cm'
      }}
    >
      {/* Front side */}
      <div
        style={{
          width: '10cm',
          height: '6.5cm',
          border: '1px solid black',
          padding: '0.2cm',
          boxSizing: 'border-box',
          backgroundColor: '#fff',
          borderRight: 'none',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <div style={{display: 'flex', flexGrow: 1}}>
          {/* Image section */}
          <div
            style={{
              flex: '0 0 40%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <img
              src="img/image.png"
              alt="logo"
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '1cm',
                objectFit: 'cover',
                marginBottom: '7.5px'
              }}
            />
            <div
              style={{
                width: '150px',
                height: '150px',
                overflow: 'hidden',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              <img
                src={`https://itservice.advanceagro.net/EmployeeCard/empimages/${trainee.EMPID}.jpg`}
                alt="image"
                style={{
                  width: '100%',
                  height: '100%',
                  border: '1px solid black',
                  padding: '3px',
                  objectFit: 'cover'
                }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null;
                  target.src = `https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=${trainee.EMPID}&Size=128`;
                }}
              />
            </div>
          </div>

          {/* Info section */}
          <div
            style={{
              flex: '1 1 auto',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              wordBreak: 'break-word',
              paddingLeft: '0.3cm',
              position: 'relative'
            }}
          >
            <div style={{ marginBottom: '0.3em' }}>
              <strong>บัตรอนุญาตขับขี่<br/>รถฟอร์คลิฟท์และรถคีบม้วน</strong>
            </div>
            <div
              style={{
                fontSize: '0.7em',
                color: '#666',
                fontWeight: 550,
                marginBottom: '0.5rem'
              }}
            >
              FORKLIFT & Roll Clamp LICENSE
            </div>
            {trainee?.DRIVER_NO && (
              <div style={{marginBottom: '0.3em', fontSize: '0.9em'}}>
                <span style={{fontWeight: 'bold'}}>
                  เลขที่ {trainee.DRIVER_NO}
                </span>{' '}
                <br />
              </div>
            )}
            <div style={{marginBottom: '0.5em', fontSize: '0.9em'}}>
              <span style={{color: '#1004b6ff'}}>{trainee.NAME}</span> <br />
              <span>หน่วยงาน: </span>
              <span
                style={{
                  color: '#1004b6ff',
                  wordBreak: 'break-word',
                  fontSize: trainee.DEPARTMENT?.length > 40 ? '10px' : '13px',
                  lineHeight: '1.2em'
                }}
              >
                {trainee.DEPARTMENT}
              </span>
            </div>

            {/* ลงชื่อผู้อนุญาต - อยู่ล่างสุดเสมอ */}
            <div
              style={{
                fontSize: '0.9em',
                position: 'absolute',
                bottom: '0',
                left: '0.3cm',
                right: '0'
              }}
            >
              <span>
                ลงชื่อผู้อนุญาต{' '}
                {trainer?.[0]?.question_answer && (
                  <img
                    src={trainer[0].question_answer}
                    alt="signature"
                    style={{
                      height: '25px',
                      width: 'auto',
                      objectFit: 'contain',
                      verticalAlign: 'middle',
                      marginLeft: '8px'
                    }}
                  />
                )}
              </span>
              <br />
              <span>( {trainer?.[0]?.NAME || ''} )</span>
            </div>
          </div>
        </div>

        {/* Date row */}
        <div
          style={{fontSize: '0.75em', marginTop: '0.1cm', textAlign: 'left'}}
        >
          <span style={{color: 'green', marginRight: '10px'}}>
            วันออกบัตร: {formatThaiDate(item.TRAINING_DATE_TRAINING) || '-'}
          </span>
          <span style={{color: 'red'}}>
            วันหมดอายุ: {formatThaiDate(item.TRAINING_EXPIRED_DATE) || '-'}
          </span>
        </div>
        <div style={{ fontSize: '0.75em', marginTop: '0.1cm', textAlign: 'left' }}>
          <span style={{ marginRight: '10px' }}>
            Double A (1991) Public Company Limited.
          </span>
        </div>
      </div>

      {/* Back side */}
      <div
        style={{
          width: '10cm',
          height: '6.5cm',
          border: '1px solid black',
          padding: '0.4cm',
          boxSizing: 'border-box',
          backgroundColor: '#fff',
          fontSize: '0.85em'
        }}
      >
        <ul style={{paddingLeft: '1em', margin: 0}}>
          <li>
            ติดบัตรทุกครั้งเมื่อขับรถฟอร์คลิฟท์ (FolkLift) และรถคีบม้วน (Roll
            Clamp)
          </li>
          <li>
            ต้องต่ออายุบัตรก่อนถึงวันหมดอายุ
            โดยผู้ขับขี่ต้องได้รับการอบรมจากผู้ชำนาญการเท่านั้น
          </li>
          <li>
            ต้องปฏิบัติตามกฎระเบียบการขับรถฟอร์คลิฟท์ (Folklift) และรถคีบม้วน
            (Roll Clamp) อย่างเคร่งครัด หากผู้ใดฝ่าฝืน
            หรือกระทำความผิดจะถูกลงโทษ
          </li>
        </ul>
        <p style={{ marginTop: '1em', textAlign: 'center' }}>
          <strong style={{ fontSize: '13.5px' }}>บริษัท ดั๊บเบิ้ลเอ (1991) จำกัด (มหาชน)<br/>1 หมู่ 2 ต.ท่าตูม อ.ศรีมหาโพธิ จ.ปราจีนบุรี 25140</strong>
        </p>
        <p style={{ marginTop: '1.6em', fontSize: '15px', textAlign: 'center' }}>
          ฝ่ายความปลอดภัยโทร <strong style={{ fontSize: '13.5px' }}>085-835-4738</strong>
        </p>
      </div>
    </div>
  </div>
);

const CardNPS = ({trainee, score, trainer, item}: any) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      marginBottom: '1cm',
      pageBreakInside: 'avoid'
    }}
  >
    <div
      style={{
        display: 'flex',
        width: '20cm',
        height: '6cm'
      }}
    >
      {/* Front side */}
      <div
        style={{
          width: '10cm',
          height: '6.5cm',
          border: '1px solid black',
          padding: '0.2cm',
          boxSizing: 'border-box',
          backgroundColor: '#fff',
          borderRight: 'none',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <div style={{display: 'flex', flexGrow: 1}}>
          {/* Image section */}
          <div
            style={{
              flex: '0 0 40%',
              display: 'flex',
              flexDirection: 'column'
              // alignItems: 'center'
            }}
          >
            <img
              src="https://www.npsplc.com/themes/default/assets/static/images/logo/logo.png"
              alt="logo"
              style={{
                width: '40%',
                height: 'auto',
                maxHeight: '1cm',
                objectFit: 'cover',
                margin: '0 0 7.5px 0',
                display: 'block'
              }}
            />
            <div
              style={{
                width: '150px',
                height: '150px',
                overflow: 'hidden',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              <img
                src={`https://itservice.advanceagro.net/EmployeeCard/empimages/${trainee.EMPID}.jpg`}
                alt="image"
                style={{
                  width: '100%',
                  height: '100%',
                  border: '1px solid black',
                  padding: '3px',
                  objectFit: 'cover'
                }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null;
                  target.src = `https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=${trainee.EMPID}&Size=128`;
                }}
              />
            </div>
          </div>

          {/* Info section */}
          <div
            style={{
              flex: '1 1 auto',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              wordBreak: 'break-word',
              paddingLeft: '0.3cm',
              position: 'relative'
            }}
          >
            <div style={{marginBottom: '0.3em'}}>
              <strong>
                บัตรอนุญาต
                <br />
                ขับรถฟอร์คลิฟท์ และรถคีบม้วน
              </strong>
            </div>
            <div
              style={{
                fontSize: '0.7em',
                color: '#666',
                fontWeight: 550,
                marginBottom: '0.5rem'
              }}
            >
              FORKLIFT & Roll Clamp LICENSE
            </div>
            {trainee?.DRIVER_NO && (
              <div style={{marginBottom: '0.3em', fontSize: '0.8em'}}>
                <span style={{fontWeight: 'bold'}}>
                  เลขที่ {trainee.DRIVER_NO}
                </span>{' '}
                <br />
              </div>
            )}
            <div style={{marginBottom: '0.5em', fontSize: '0.9em'}}>
              <span style={{color: '#1004b6ff', fontWeight: 'bold'}}>
                {trainee.NAME}
              </span>{' '}
              <br />
              <span>สายงาน: </span>
              <span
                style={{
                  color: '#1004b6ff',
                  wordBreak: 'break-word',
                  fontSize: trainee.LINEOFWORK?.length > 40 ? '10px' : '13px',
                  lineHeight: '1.2em'
                }}
              >
                {trainee.LINEOFWORK}
              </span>
            </div>

            {/* ลงชื่อผู้อนุญาต - อยู่ล่างสุดเสมอ */}
            <div
              style={{
                fontSize: '0.9em',
                position: 'absolute',
                bottom: '0',
                left: '0.3cm',
                right: '0'
              }}
            >
              <span>
                ลงชื่อผู้อนุญาต{' '}
                {trainer?.[0]?.question_answer && (
                  <img
                    src={trainer[0].question_answer}
                    alt="signature"
                    style={{
                      height: '25px',
                      width: 'auto',
                      objectFit: 'contain',
                      verticalAlign: 'middle',
                      marginLeft: '8px'
                    }}
                  />
                )}
              </span>
              <br />
              <span>( {trainer?.[0]?.NAME || ''} )</span>
            </div>
          </div>
        </div>

        {/* Date row */}
        <div
          style={{fontSize: '0.75em', marginTop: '0.1cm', textAlign: 'left'}}
        >
          <span style={{color: 'green', marginRight: '10px'}}>
            วันออกบัตร: {formatThaiDate(item.TRAINING_DATE_TRAINING) || '-'}
          </span>
          <span style={{color: 'red'}}>
            วันหมดอายุ: {formatThaiDate(item.DRIVING_LICENSE_END) || '-'}
          </span>
        </div>
        <div
          style={{fontSize: '0.75em', marginTop: '0.1cm', textAlign: 'center'}}
        >
          <span style={{marginRight: '10px', textAlign: 'center'}}>
            National Power Supply Company Limited
          </span>
        </div>
      </div>

      {/* Back side */}
      <div
        style={{
          width: '10cm',
          height: '6.5cm',
          border: '1px solid black',
          padding: '0.4cm',
          boxSizing: 'border-box',
          backgroundColor: '#fff',
          fontSize: '0.85em'
        }}
      >
        <ul style={{paddingLeft: '1em', margin: 0}}>
          <li>
            ติดบัตรทุกครั้งเมื่อขับรถฟอร์คลิฟท์ (FolkLift) และรถคีบม้วน (Roll
            Clamp)
          </li>
          <li>
            ต้องต่ออายุบัตรก่อนถึงวันหมดอายุ
            โดยผู้ขับขี่ต้องได้รับการอบรมจากผู้ชำนาญการเท่านั้น
          </li>
          <li>
            ต้องปฏิบัติตามกฎระเบียบการขับรถฟอร์คลิฟท์ (Folklift) และรถคีบม้วน
            (Roll Clamp) อย่างเคร่งครัด หากผู้ใดฝ่าฝืน
            หรือกระทำความผิดจะถูกลงโทษ
          </li>
        </ul>
        <p style={{marginTop: '1em', textAlign: 'center'}}>
          <strong style={{fontSize: '13.5px', color: '#1004b6ff'}}>
            บริษัท เนชั่นแนล เพาเวอร์ ซัพพลาย จำกัด (มหาชน)
            <br />
            206 หมู่ 4 ต.ท่าตูม อ.ศรีมหาโพธิ จ.ปราจีนบุรี 25140
          </strong>
        </p>
        <p style={{marginTop: '1.6em', fontSize: '15px', textAlign: 'center'}}>
          ฝ่ายความปลอดภัย ติดต่อ{' '}
          <strong style={{fontSize: '13.5px'}}>{trainee.SAFETY}</strong>
        </p>
      </div>
    </div>
  </div>
);

const FolkliftCers = ({item, trainer, trainee, score}) => {
  const componentRef = useRef(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [dot, setDot] = useState('.');
  const [mode, setMode] = useState('AA');

  useEffect(() => {
    if (isPrinting) {
      const interval = setInterval(() => {
        setDot((prev) => (prev.length >= 3 ? '.' : prev + '.'));
      }, 300);
      return () => clearInterval(interval);
    } else {
      setDot('.');
    }
  }, [isPrinting]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @media print {
        .print-container {
          height: auto !important;
          overflow: visible !important;
        }
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          background: white;
        }
        @page {
          size: A4 portrait;
          margin: 10mm;
        }
      }
    `,
    onBeforeGetContent: () => {
      setIsPrinting(true);
    },
    onAfterPrint: () => {
      setIsPrinting(false);
    },
    removeAfterPrint: true
  });

  const passedTrainees =
    trainee?.filter((t) => {
      const s = score.find((s) => s.EMPID === t.EMPID);
      return s?.IS_PASSED === true;
    }) || [];

  return (
    <div className="content">
      {/* แสดงปุ่มเฉพาะเมื่อมีข้อมูล */}
      {passedTrainees.length > 0 && (
        <div
          className="print-button d-flex justify-content-end mb-1"
          style={{display: 'flex', gap: '10px'}}
        >
          <Button
            variant="primary"
            onClick={() => setMode('AA')}
            style={{
              width: '150px',
              textAlign: 'center',
              whiteSpace: 'nowrap',
              backgroundColor: '#00e5f9',
              borderColor: '#00e5f9',
              color: '#000'
            }}
          >
            aA
          </Button>

          <Button
            variant="primary"
            onClick={() => setMode('NPS')}
            style={{
              width: '150px',
              textAlign: 'center',
              whiteSpace: 'nowrap',
              backgroundColor: '#fef200',
              borderColor: '#fef200',
              color: '#000'
            }}
          >
            <>NPS</>
          </Button>

          <Button
            variant="primary"
            onClick={handlePrint}
            disabled={isPrinting}
            style={{
              width: '150px',
              textAlign: 'center',
              whiteSpace: 'nowrap'
            }}
          >
            {isPrinting ? (
              <>
                🖨️ Printing
                <span style={{display: 'inline-block', minWidth: '1.5em'}}>
                  {dot}
                </span>
              </>
            ) : (
              '🖨️ Print License'
            )}
          </Button>
        </div>
      )}

      {/* Content */}
      <div
        ref={componentRef}
        className="print-container d-flex flex-column align-items-center"
        style={{
          height: 'calc(100vh - 250px)',
          overflowY: 'auto',
          padding: '1cm'
        }}
      >
        {passedTrainees.length > 0 ? (
          passedTrainees.map((t: any, index: number) =>
            mode === 'AA' ? (
              <Card
                key={t.EMPID || index}
                trainee={t}
                score={score}
                trainer={trainer}
                item={item}
              />
            ) : (
              <CardNPS
                key={t.EMPID || index}
                trainee={t}
                score={score}
                trainer={trainer}
                item={item}
              />
            )
          )
        ) : (
          <div
            style={{
              fontSize: '1.1em',
              color: '#777',
              marginTop: '2rem'
            }}
          >
            ยังไม่พบข้อมูลผู้ที่ผ่านการอบรม Folklift & Roll Clamp
          </div>
        )}
      </div>
    </div>
  );
};

export default FolkliftCers;
